import { render, staticRenderFns } from "./Kataloganfordern.vue?vue&type=template&id=ef4c40a2&scoped=true&"
import script from "./Kataloganfordern.vue?vue&type=script&lang=js&"
export * from "./Kataloganfordern.vue?vue&type=script&lang=js&"
import style0 from "./Kataloganfordern.vue?vue&type=style&index=0&id=ef4c40a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4c40a2",
  null
  
)

export default component.exports